import { openOutsideWebViewNative } from '@/shared/utils/nativeBridge';

/**
 * Binaries with the bridge open the store through `OPEN_EXTERNAL`. 1.4.0 has no bridge:
 * its shell sends a top-level navigation to a host outside its allowed list to the
 * system browser (see `shared/download/legacyShellNavigation.ts`).
 */
export const openStore = (storeUrl: string): void => {
	if (openOutsideWebViewNative(storeUrl)) return;
	window.location.assign(storeUrl);
};
